export default __webpack_public_path__ + "static/applozic_cs_cover-be28db0e2dc83e4a9a3bb8ec619cc711.png";